import Vue from 'vue'
import { getProductPlaceholder, getBannerPlaceholder, getCategoryPlaceholder } from '@/utils/placeholder'

Vue.prototype.$store = new Vue({
  data() {
    return {
      // 产品数据
      products: [
        {
          id: 1,
          name: 'Formaldehyde Solution 37%',
          nameZh: '工业甲醛溶液',
          category: 'formaldehyde',
          categoryName: 'Formaldehyde Series',
          categoryNameZh: '甲醛系列',
          image: getProductPlaceholder(1, 'formaldehyde'),
          gallery: [
            getProductPlaceholder(1, 'formaldehyde'),
            getProductPlaceholder(101, 'formaldehyde'),
            getProductPlaceholder(201, 'formaldehyde')
          ],
          spec: 'CH₂O, Purity: 37% min, Industrial Grade',
          specZh: 'CH₂O, 纯度: ≥37%, 工业级',
          specs: [
            { label: 'Appearance', value: 'Colorless transparent liquid' },
            { label: 'Formaldehyde Content', value: '37%-40%' },
            { label: 'Methanol Content', value: '≤1.5%' },
            { label: 'Acidity (as formic acid)', value: '≤0.05%' },
            { label: 'Iron Content', value: '≤5ppm' },
            { label: 'Density (20°C)', value: '1.08-1.10 g/cm³' }
          ],
          specsZh: [
            { label: '外观', value: '无色透明液体' },
            { label: '甲醛含量', value: '37%-40%' },
            { label: '甲醇含量', value: '≤1.5%' },
            { label: '酸度（以甲酸计）', value: '≤0.05%' },
            { label: '铁含量', value: '≤5ppm' },
            { label: '密度（20°C）', value: '1.08-1.10 g/cm³' }
          ],
          price: null,
          moq: '20 MT',
          moqZh: '20 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'Produced with advanced technology, this high-quality industrial-grade formaldehyde solution features high purity and excellent stability. Widely used in urea-formaldehyde and phenolic resin synthesis, textile anti-wrinkle finishing, and pesticide/pharmaceutical intermediate production.',
          descriptionZh: '采用先进技术生产的高品质工业级甲醛溶液，纯度高、稳定性优异。广泛应用于脲醛树脂和酚醛树脂合成、织物防皱整理，以及农药和医药中间体的生产。'
        },
        {
          id: 2,
          name: 'Paraformaldehyde 96%',
          nameZh: '多聚甲醛 96%',
          category: 'formaldehyde',
          categoryName: 'Formaldehyde Series',
          categoryNameZh: '甲醛系列',
          image: getProductPlaceholder(2, 'formaldehyde'),
          gallery: [
            getProductPlaceholder(2, 'formaldehyde'),
            getProductPlaceholder(102, 'formaldehyde'),
            getProductPlaceholder(202, 'formaldehyde')
          ],
          spec: '(CH₂O)n, Purity: 96% min, White Powder',
          specZh: '(CH₂O)n, 纯度: ≥96%, 白色粉末',
          specs: [
            { label: 'Appearance', value: 'White powder' },
            { label: 'Content', value: '≥96%' },
            { label: 'Acidity', value: '≤0.03%' },
            { label: 'Iron Content', value: '≤5ppm' },
            { label: 'Moisture', value: '≤0.5%' },
            { label: 'Ignition Residue', value: '≤0.03%' }
          ],
          specsZh: [
            { label: '外观', value: '白色粉末' },
            { label: '含量', value: '≥96%' },
            { label: '酸度', value: '≤0.03%' },
            { label: '铁含量', value: '≤5ppm' },
            { label: '水分', value: '≤0.5%' },
            { label: '灼烧残渣', value: '≤0.03%' }
          ],
          price: null,
          moq: '10 MT',
          moqZh: '10 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'Premium paraformaldehyde for disinfectant, pesticide, and resin manufacturing.',
          descriptionZh: '优质多聚甲醛，用于消毒剂、农药和树脂制造。'
        },
        {
          id: 3,
          name: 'Urea Formaldehyde Concentrate 85%',
          nameZh: '脲醛预缩液 85%',
          category: 'formaldehyde',
          categoryName: 'Formaldehyde Series',
          categoryNameZh: '甲醛系列',
          image: getProductPlaceholder(3, 'formaldehyde'),
          gallery: [
            getProductPlaceholder(3, 'formaldehyde'),
            getProductPlaceholder(103, 'formaldehyde'),
            getProductPlaceholder(203, 'formaldehyde')
          ],
          spec: 'UFC, Purity: 85% min, Clear Liquid',
          specZh: 'UFC, 纯度: ≥85%, 透明液体',
          specs: [
            { label: 'Appearance', value: 'Clear liquid' },
            { label: 'Urea Content', value: '25±1%' },
            { label: 'Formaldehyde Content', value: '60±1%' },
            { label: 'Density', value: '1.295-1.315 g/cm³' },
            { label: 'pH Value', value: '7.0-8.5' },
            { label: 'Storage Temperature', value: '15-25°C' }
          ],
          specsZh: [
            { label: '外观', value: '透明液体' },
            { label: '尿素含量', value: '25±1%' },
            { label: '甲醛含量', value: '60±1%' },
            { label: '密度', value: '1.295-1.315 g/cm³' },
            { label: 'pH值', value: '7.0-8.5' },
            { label: '储存温度', value: '15-25°C' }
          ],
          price: null,
          moq: '20 MT',
          moqZh: '20 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'Urea formaldehyde concentrate for adhesive and resin industry applications.',
          descriptionZh: '脲醛预缩液，用于胶粘剂和树脂行业应用。'
        },
        {
          id: 4,
          name: 'Methanol 99.9%',
          nameZh: '甲醇 99.9%',
          category: 'organic',
          categoryName: 'Organic Chemicals',
          categoryNameZh: '有机化工原料',
          image: getProductPlaceholder(4, 'organic'),
          gallery: [
            getProductPlaceholder(4, 'organic'),
            getProductPlaceholder(104, 'organic'),
            getProductPlaceholder(204, 'organic')
          ],
          spec: 'CH₃OH, Purity: 99.9% min, Industrial Grade',
          specZh: 'CH₃OH, 纯度: ≥99.9%, 工业级',
          specs: [
            { label: 'Appearance', value: 'Colorless transparent liquid' },
            { label: 'Purity', value: '≥99.9%' },
            { label: 'Moisture', value: '≤0.05%' },
            { label: 'Acidity', value: '≤0.0015%' },
            { label: 'Alkalinity', value: '≤0.0002%' },
            { label: 'Density', value: '0.791-0.793 g/cm³' }
          ],
          specsZh: [
            { label: '外观', value: '无色透明液体' },
            { label: '纯度', value: '≥99.9%' },
            { label: '水分', value: '≤0.05%' },
            { label: '酸度', value: '≤0.0015%' },
            { label: '碱度', value: '≤0.0002%' },
            { label: '密度', value: '0.791-0.793 g/cm³' }
          ],
          price: null,
          moq: '20 MT',
          moqZh: '20 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'High purity methanol for chemical synthesis, solvent, and fuel applications.',
          descriptionZh: '高纯度甲醇，用于化学合成、溶剂和燃料应用。'
        },
        {
          id: 5,
          name: 'Acetic Acid 99.8%',
          nameZh: '冰醋酸 99.8%',
          category: 'organic',
          categoryName: 'Organic Chemicals',
          categoryNameZh: '有机化工原料',
          image: getProductPlaceholder(5, 'organic'),
          gallery: [
            getProductPlaceholder(5, 'organic'),
            getProductPlaceholder(105, 'organic'),
            getProductPlaceholder(205, 'organic')
          ],
          spec: 'CH₃COOH, Purity: 99.8% min, Industrial Grade',
          specZh: 'CH₃COOH, 纯度: ≥99.8%, 工业级',
          specs: [
            { label: 'Appearance', value: 'Colorless transparent liquid' },
            { label: 'Purity', value: '≥99.8%' },
            { label: 'Moisture', value: '≤0.15%' },
            { label: 'Formic Acid', value: '≤0.05%' },
            { label: 'Acetaldehyde', value: '≤0.01%' },
            { label: 'Iron', value: '≤0.0001%' }
          ],
          specsZh: [
            { label: '外观', value: '无色透明液体' },
            { label: '纯度', value: '≥99.8%' },
            { label: '水分', value: '≤0.15%' },
            { label: '甲酸', value: '≤0.05%' },
            { label: '乙醛', value: '≤0.01%' },
            { label: '铁', value: '≤0.0001%' }
          ],
          price: null,
          moq: '20 MT',
          moqZh: '20 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'Premium glacial acetic acid for textile, pharmaceutical and food industries.',
          descriptionZh: '优质冰醋酸，用于纺织、制药和食品行业。'
        },
        {
          id: 6,
          name: 'Sodium Hydroxide 99%',
          nameZh: '氢氧化钠 99%',
          category: 'inorganic',
          categoryName: 'Inorganic Chemicals',
          categoryNameZh: '无机化工原料',
          image: getProductPlaceholder(6, 'inorganic'),
          gallery: [
            getProductPlaceholder(6, 'inorganic'),
            getProductPlaceholder(106, 'inorganic'),
            getProductPlaceholder(206, 'inorganic')
          ],
          spec: 'NaOH, Purity: 99% min, Flakes/Solid',
          specZh: 'NaOH, 纯度: ≥99%, 片状/固体',
          specs: [
            { label: 'Appearance', value: 'White flakes' },
            { label: 'NaOH Content', value: '≥99%' },
            { label: 'Na₂CO₃', value: '≤0.5%' },
            { label: 'NaCl', value: '≤0.03%' },
            { label: 'Fe₂O₃', value: '≤0.003%' },
            { label: 'Density', value: '2.13 g/cm³' }
          ],
          specsZh: [
            { label: '外观', value: '白色片状' },
            { label: 'NaOH含量', value: '≥99%' },
            { label: '碳酸钠', value: '≤0.5%' },
            { label: '氯化钠', value: '≤0.03%' },
            { label: '氧化铁', value: '≤0.003%' },
            { label: '密度', value: '2.13 g/cm³' }
          ],
          price: null,
          moq: '25 MT',
          moqZh: '25 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'High purity caustic soda for paper, textile, and chemical industries.',
          descriptionZh: '高纯度烧碱，用于造纸、纺织和化工行业。'
        },
        {
          id: 7,
          name: 'Soda Ash Light 99.2%',
          nameZh: '轻质纯碱 99.2%',
          category: 'inorganic',
          categoryName: 'Inorganic Chemicals',
          categoryNameZh: '无机化工原料',
          image: getProductPlaceholder(7, 'inorganic'),
          gallery: [
            getProductPlaceholder(7, 'inorganic'),
            getProductPlaceholder(107, 'inorganic'),
            getProductPlaceholder(207, 'inorganic')
          ],
          spec: 'Na₂CO₃, Purity: 99.2% min, White Powder',
          specZh: 'Na₂CO₃, 纯度: ≥99.2%, 白色粉末',
          specs: [
            { label: 'Appearance', value: 'White powder' },
            { label: 'Na₂CO₃', value: '≥99.2%' },
            { label: 'NaCl', value: '≤0.7%' },
            { label: 'Iron', value: '≤0.004%' },
            { label: 'Insoluble Matter', value: '≤0.04%' },
            { label: 'Bulk Density', value: '0.5-0.6 g/cm³' }
          ],
          specsZh: [
            { label: '外观', value: '白色粉末' },
            { label: '碳酸钠', value: '≥99.2%' },
            { label: '氯化钠', value: '≤0.7%' },
            { label: '铁', value: '≤0.004%' },
            { label: '水不溶物', value: '≤0.04%' },
            { label: '堆积密度', value: '0.5-0.6 g/cm³' }
          ],
          price: null,
          moq: '25 MT',
          moqZh: '25 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'Premium soda ash for glass, detergent, and chemical manufacturing.',
          descriptionZh: '优质纯碱，用于玻璃、洗涤剂和化工制造。'
        },
        {
          id: 8,
          name: 'Calcium Carbide 295L/kg',
          nameZh: '电石 295L/kg',
          category: 'inorganic',
          categoryName: 'Inorganic Chemicals',
          categoryNameZh: '无机化工原料',
          image: getProductPlaceholder(8, 'inorganic'),
          gallery: [
            getProductPlaceholder(8, 'inorganic'),
            getProductPlaceholder(108, 'inorganic'),
            getProductPlaceholder(208, 'inorganic')
          ],
          spec: 'CaC₂, Gas Yield: 295 L/kg min, 25-50mm',
          specZh: 'CaC₂, 发气量: ≥295 L/kg, 25-50mm',
          specs: [
            { label: 'Appearance', value: 'Gray-black lumps' },
            { label: 'Gas Yield', value: '≥295 L/kg' },
            { label: 'Phosphine', value: '≤0.06%' },
            { label: 'Hydrogen Sulfide', value: '≤0.10%' },
            { label: 'Particle Size', value: '25-50mm' },
            { label: 'Carbon Content', value: '≤1.0%' }
          ],
          specsZh: [
            { label: '外观', value: '灰黑色块状' },
            { label: '发气量', value: '≥295 L/kg' },
            { label: '磷化氢', value: '≤0.06%' },
            { label: '硫化氢', value: '≤0.10%' },
            { label: '粒度', value: '25-50mm' },
            { label: '含碳量', value: '≤1.0%' }
          ],
          price: null,
          moq: '22.5 MT',
          moqZh: '22.5 吨',
          delivery: '7-15 days',
          deliveryZh: '7-15 天',
          description: 'High quality calcium carbide for acetylene gas production and steel manufacturing.',
          descriptionZh: '优质电石，用于乙炔气体生产和钢铁制造。'
        }
      ],
      // 实力背书数据
      stats: [
        { icon: 'dollar-circle', value: '$12.68M', label: 'Annual Export', labelZh: '年度出口额', desc: 'Stable annual export volume with continuous growth', descZh: '稳定年度出口量，持续增长' },
        { icon: 'calendar', value: '15+', label: 'Years Experience', labelZh: '行业经验', desc: 'Deep expertise in chemical raw material trading', descZh: '深厚的化工原料贸易专业经验' },
        { icon: 'global', value: '30+', label: 'Countries Served', labelZh: '服务国家', desc: 'Global network covering major markets worldwide', descZh: '覆盖全球主要市场的全球网络' },
        { icon: 'setting', value: 'OEM/ODM', label: 'Custom Service', labelZh: '定制服务', desc: 'Customized packaging, specifications and logistics solutions', descZh: '定制包装、规格和物流解决方案' },
        { icon: 'home', value: '50,000m²', label: 'Warehouse Area', labelZh: '仓储面积', desc: 'Modern warehouse facilities in Qingdao FTZ', descZh: '青岛自贸区现代化仓储设施' },
        { icon: 'safety-certificate', value: 'ISO 9001', label: 'Certified', labelZh: '资质认证', desc: 'International quality management system certified', descZh: '国际质量管理体系认证' }
      ],
      // Banner 数据
      banners: [
        {
          id: 1,
          title: 'Qingdao FTZ Source Supply',
          titleZh: '青岛自贸区源头货源',
          subtitle: 'Professional chemical raw material supply chain service platform',
          subtitleZh: '专业化工原材料供应链服务平台',
          cta1: 'Get Quote',
          cta1Zh: '获取报价',
          cta2: 'View Products',
          cta2Zh: '查看产品',
          bg: getBannerPlaceholder(1)
        },
        {
          id: 2,
          title: 'Premium Formaldehyde Products',
          titleZh: '优质甲醛系列产品',
          subtitle: '37% Solution, 96% Paraformaldehyde, UFC 85% — Full product line coverage',
          subtitleZh: '37%溶液、96%多聚甲醛、UFC 85% — 全系列产品覆盖',
          cta1: 'Inquire Now',
          cta1Zh: '立即询盘',
          cta2: 'Learn More',
          cta2Zh: '了解更多',
          bg: getBannerPlaceholder(2)
        },
        {
          id: 3,
          title: 'Free Trade Zone Advantage',
          titleZh: '自贸区区位优势',
          subtitle: 'Faster customs clearance, lower logistics costs, professional trade services',
          subtitleZh: '更快通关、更低物流成本、专业贸易服务',
          cta1: 'Contact Us',
          cta1Zh: '联系我们',
          cta2: 'Our Services',
          cta2Zh: '服务介绍',
          bg: getBannerPlaceholder(3)
        }
      ],
      // 产品分类
      categories: [
        { key: 'formaldehyde', name: 'Formaldehyde Series', nameZh: '甲醛系列', icon: 'experiment', image: getCategoryPlaceholder('formaldehyde'), desc: 'Formaldehyde solution, paraformaldehyde, UFC and more', descZh: '甲醛溶液、多聚甲醛、UFC等' },
        { key: 'organic', name: 'Organic Chemicals', nameZh: '有机化工原料', icon: 'container', image: getCategoryPlaceholder('organic'), desc: 'Methanol, acetic acid, solvents and intermediates', descZh: '甲醇、冰醋酸、溶剂及中间体' },
        { key: 'inorganic', name: 'Inorganic Chemicals', nameZh: '无机化工原料', icon: 'fund', image: getCategoryPlaceholder('inorganic'), desc: 'Caustic soda, soda ash, calcium carbide and more', descZh: '烧碱、纯碱、电石等' },
        { key: 'custom', name: 'Custom Services', nameZh: '定制服务', icon: 'tool', image: getCategoryPlaceholder('custom'), desc: 'OEM packaging, custom specs, tailored logistics', descZh: 'OEM包装、定制规格、专属物流' }
      ],
      // 联系信息
      contact: {
        phone: '+86-532-8888-6666',
        email: 'info@qingdaoftz-chem.com',
        address: 'No. 168, Qianwan Road, Qingdao Free Trade Zone, Shandong, China',
        addressZh: '中国山东省青岛自贸区前湾路168号',
        wechat: 'QDFTZ_Chem',
        workingHours: 'Mon-Fri 9:00-18:00 (GMT+8)',
        workingHoursZh: '周一至周五 9:00-18:00 (GMT+8)'
      },
      // 服务流程
      serviceFlow: [
        { step: 1, title: 'Inquiry', titleZh: '询盘咨询', desc: 'Submit your requirements via form or email', descZh: '通过表单或邮件提交需求' },
        { step: 2, title: 'Quotation', titleZh: '报价方案', desc: 'Professional quotation within 24 hours', descZh: '24小时内提供专业报价' },
        { step: 3, title: 'Contract', titleZh: '合同签订', desc: 'Clear terms with secure trade process', descZh: '条款清晰，安全交易流程' },
        { step: 4, title: 'Production', titleZh: '生产备货', desc: 'Strict quality control and inspection', descZh: '严格质量控制和检验' },
        { step: 5, title: 'Logistics', titleZh: '物流运输', desc: 'FTZ customs clearance, global delivery', descZh: '自贸区通关，全球交付' },
        { step: 6, title: 'After-Sales', titleZh: '售后服务', desc: 'Dedicated support throughout cooperation', descZh: '全程专属支持服务' }
      ],
      // 语言
      locale: 'en'
    }
  },
  methods: {
    setLocale(lang) {
      this.locale = lang
    }
  }
})
